import React from 'react';
import logoImg from '../assets/logo.png';

const Logo = ({ size = 'medium', dark = false }) => {
    // Determine dimensions
    const dim = size === 'large' ? '120px' : '40px';
    const textSize = size === 'large' ? '2rem' : '1.2rem';

    const styles = {
        container: {
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            textDecoration: 'none',
            // LOGIC: If 'dark' prop is true (Login screen), use dark text.
            // Otherwise (Navbar), use White text.
            color: dark ? '#212529' : '#ffffff', 
            fontFamily: "'Segoe UI', sans-serif",
            fontWeight: 'bold',
        },
        image: {
            width: dim,
            height: dim,
            objectFit: 'contain',
            borderRadius: '50%', 
            border: '2px solid var(--primary)',
            background: 'white'
        },
        text: {
            fontSize: textSize,
            letterSpacing: '-0.5px'
        },
        highlight: {
            color: '#FFC107' // Always Gold
        }
    };

    return (
        <div style={styles.container}>
            <img src={logoImg} alt="You-Bee Logo" style={styles.image} />
            <span style={styles.text}>
                You-<span style={styles.highlight}>Bee</span>
            </span>
        </div>
    );
};

export default Logo;
